import React from "react";
import "../../../css/Home.css";
import { NavLink } from "react-router-dom";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";

export default function RegisterNav({ color }) {
  const style = {
    active: `text-red-500 ${color}-600 uppercase font-bold`,
    inactive: `text-${color}-600 text-white uppercase font-bold hidden`,
  };
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      <ul className="flex justify-between mb-6 mx-6" role="tablist">
        <li className="-mb-px mr-2 last:mr-0 flex-auto text-left hidden">
          <NavLink
            className={({ isActive, isPending }) =>
              isPending ? "" : isActive ? style.active : style.inactive
            }
            to="/register/athlete"
          >
            Athlete Registration
          </NavLink>
        </li>
        <li className="-mb-px mr-2 last:mr-0 flex-auto text-center hidden">
          <NavLink
            className={({ isActive, isPending }) =>
              isPending ? "" : isActive ? style.active : style.inactive
            }
            to="/register/coach"
          >
            Coach Registration
          </NavLink>
        </li>
        {!isAuthenticated && (
          <li className="-mb-px mr-2 last:mr-0 flex-auto text-xl text-left">
            <NavLink
              className={({ isActive, isPending }) =>
                isPending ? "" : isActive ? style.active : style.inactive
              }
              to="/sign-in"
            >
              Sign In
            </NavLink>
          </li>
        )}
      </ul>
    </>
  );
}
